module.exports = __webpack_public_path__ + "img/manage-vehicle-1.8e445b18.gif";